import {Injectable, signal} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class BrowserDetectorService {
	constructor() {
	}

	getBrowserInfo(): { name: string, version: string } {
		const userAgent = window.navigator.userAgent.toLowerCase();
		let browserName = 'unknown';
		let browserVersion = 'unknown';

		if (userAgent.indexOf('edge') > -1) {
			browserName = 'Microsoft Edge';
			const match = userAgent.match(/edge\/(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		} else if (userAgent.indexOf('edg') > -1) {
			browserName = 'Chromium-based Edge';
			const match = userAgent.match(/edg\/(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		} else if (userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1) {
			browserName = 'Opera';
			const match = userAgent.match(/(opr|opera)\/(\d+\.\d+)/);
			if (match) browserVersion = match[2];
		} else if (userAgent.indexOf('chrome') > -1) {
			browserName = 'Chrome';
			const match = userAgent.match(/chrome\/(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		} else if (userAgent.indexOf('trident') > -1) {
			browserName = 'Internet Explorer';
			const match = userAgent.match(/rv:(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		} else if (userAgent.indexOf('firefox') > -1) {
			browserName = 'Firefox';
			const match = userAgent.match(/firefox\/(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		} else if (userAgent.indexOf('safari') > -1) {
			browserName = 'Safari';
			const match = userAgent.match(/version\/(\d+\.\d+)/);
			if (match) browserVersion = match[1];
		}

		return {name: browserName, version: browserVersion};
	}


    public lnaStatus = signal("");
	public getLNAStatus() {
        let me = this;
		const lna: PermissionName = 'local-network-access' as PermissionName;
		navigator.permissions.query({name: lna})
			.then((result) => {
                me.lnaStatus.set( result.state.toString() );
				console.log(`LNA permission state: ${result.state}`)
			});

	}
}
